var _path, _path2, _rect, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16.5C32.5 25.3365 25.3365 32.5 16.5 32.5C7.66343 32.5 0.5 25.3365 0.5 16.5C0.5 7.66343 7.66343 0.5 16.5 0.5C25.3365 0.5 32.5 7.66343 32.5 16.5Z",
    fill: "#F0E5AD",
    stroke: "#AF9253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5348 5.50731C15.8933 4.90984 16.7592 4.90984 17.1176 5.50732L27.6416 23.0475C28.0107 23.6626 27.5676 24.4453 26.8501 24.4453H5.80227C5.08487 24.4453 4.64174 23.6626 5.01084 23.0475L15.5348 5.50731Z",
    stroke: "#AF9253",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1348,
    y: 10.922,
    width: 2.1844,
    height: 7.64539,
    rx: 1,
    fill: "#AF9253"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2543,
    cy: 20.8883,
    r: 1.22872,
    fill: "#AF9253"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/Icon_Warning_Yellow.1e448cb87f530e5d6afdca1907cf2d1d.svg";
export { ForwardRef as ReactComponent };